import { render, staticRenderFns } from "./ElectrocardiographyPanel.vue?vue&type=template&id=cf3de976&scoped=true&"
import script from "./ElectrocardiographyPanel.vue?vue&type=script&lang=js&"
export * from "./ElectrocardiographyPanel.vue?vue&type=script&lang=js&"
import style0 from "./ElectrocardiographyPanel.vue?vue&type=style&index=0&id=cf3de976&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3de976",
  null
  
)

export default component.exports